import { ConfigurationOverride } from '../../../type/configuration';

export default {} as ConfigurationOverride;